import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/datepicker/datePicker.css';
import { Icon } from '@iconify/react/dist/iconify.js';

const DatePickerComponent = ({onDateChange, selectedDate, search=false, isEndDate=false, startDate=null}) => {

  const getMinDate = () => {
    if (search) return null;
    if (isEndDate) {
      return startDate || null;
    };
    return null;
  };
  return (
    <div className="date-picker">
      <div className="date-input-container">
        <DatePicker
          selected={selectedDate}
          onChange={(date) => {
            const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0);
            onDateChange(localDate);
          }}
          dateFormat="dd/MM/yyyy"
          className="date-input"
          placeholderText={"Select a date"}
          minDate={getMinDate()}
          maxDate={new Date()}
          adjustDateOnChange={new Date()}
        />
        <div className="icon-container">
        <Icon icon="solar:calendar-bold" className="calendar-icon" />
        </div>
        
        
      </div>
    </div>
  );
};

export default DatePickerComponent;